import React from "react";
import GrievanceForm from "./GrievanceForm";
import { post } from "../../../helpers/api_helper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Grievance = ({ userId, firstName, lastName, mobile }) => {
  const handleGrievanceSubmission = async (grievanceData) => {
    try {
      const response = await post("/saveGrievance", grievanceData);
      if (response.status === '1') {
        toast.success("Complain sent successfully");
      } 
    } catch (error) {
      console.error("Error updating grievance", error);
     
    }
  };

  return (
    <div>
      <ToastContainer />
      <GrievanceForm
        userId={userId}
        firstName={firstName}
        lastName={lastName}
        mobile={mobile}
        onSubmit={handleGrievanceSubmission}
      />
    </div>
  );
};

export default Grievance;
